import script from "./Enrichments.vue?vue&type=script&setup=true&lang=ts"
export * from "./Enrichments.vue?vue&type=script&setup=true&lang=ts"

import "./Enrichments.vue?vue&type=style&index=0&id=5e86d456&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e86d456"]])